// automatically generated by the FlatBuffers compiler, do not modify
export var UnionMode;
(function (UnionMode) {
    UnionMode[UnionMode["Sparse"] = 0] = "Sparse";
    UnionMode[UnionMode["Dense"] = 1] = "Dense";
})(UnionMode || (UnionMode = {}));

//# sourceMappingURL=union-mode.mjs.map
